import { Routes } from "@/router/routes";

export type CallMode = "noCall" | "inCall";
export type Roles =
  | "fronter"
  | "closer"
  | "verification"
  | "admin"
  | "customer_service";
export type UserRoles = Roles[];
export type SideBarItems = { icon: string; text: string; routeName: Routes }[];
export type AgentsFilterToggle = "all" | "online" | "offline";

export interface ActionContext {
  commit: Function;
  dispatch: Function;
  state: any;
}

export interface ScriptWizardItem {}

export interface User {
  email: string;
  contact_uri: string;
  available: boolean;
  first_name: string;
  last_name: string;
  roles: UserRoles;
  groups: string[];
  voice_token: string;
  worker_token: string;
  worker_sid: string;
  auto_accept: boolean;
  last_active?: any;
  waiting_for_call_since_ts?: string;
}

export interface NewUserPayload {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  roles?: UserRoles;
  auto_accept?: boolean;
}

export enum Features {
  Leaderboard = "Leaderboard",
  CallHistory = "CallHistory",
  Commissions = "Commissions",
  AgentDashboard = "AgentDashboard",
  DoctorNominations = "DoctorNominations",
  Leads = "Leads",
  LeadSources = "LeadSources",
  Dids = "Dids",
  OnHold = "OnHold",
  Settings = "Settings",
  RequestTakeover = "RequestTakeover",
  Verification = "Verification",
  RequestVerification = "RequestVerification",
  VerificationAdmin = "VerificationAdmin"
}
